import React, { Component } from "react";
import PropTypes from "prop-types";
import CKEditor from "@ckeditor/ckeditor5-react";
import BalloonBlockEditor from "@ckeditor/ckeditor5-editor-balloon/src/ballooneditor";
import Autoformat from "@ckeditor/ckeditor5-autoformat/src/autoformat";
import Bold from "@ckeditor/ckeditor5-basic-styles/src/bold";
import Italic from "@ckeditor/ckeditor5-basic-styles/src/italic";
import BlockQuote from "@ckeditor/ckeditor5-block-quote/src/blockquote";
import CKFinder from "@ckeditor/ckeditor5-ckfinder/src/ckfinder";
import CKFinderUploadAdapter from "@ckeditor/ckeditor5-adapter-ckfinder/src/uploadadapter";
import Heading from "@ckeditor/ckeditor5-heading/src/heading";
import Image from "@ckeditor/ckeditor5-image/src/image";
import ImageCaption from "@ckeditor/ckeditor5-image/src/imagecaption";
import ImageStyle from "@ckeditor/ckeditor5-image/src/imagestyle";
import ImageToolbar from "@ckeditor/ckeditor5-image/src/imagetoolbar";
import ImageUpload from "@ckeditor/ckeditor5-image/src/imageupload";
import ImageResize from "@ckeditor/ckeditor5-image/src/imageresize";
import Link from "@ckeditor/ckeditor5-link/src/link";
import Mention from '@ckeditor/ckeditor5-mention/src/mention';
import PasteFromOffice from "@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice";
import FontSize from "@ckeditor/ckeditor5-font/src/fontsize";
// import FontColor from "@ckeditor/ckeditor5-font/src/fontcolor";
import FontColor from "../../plugins/ckeditor5/ckeditor5-font-color/src/fontcolor";

// import FontFamily from "@ckeditor/ckeditor5-font/src/fontfamily";
import FontBackgroundColor from "@ckeditor/ckeditor5-font/src/fontbackgroundcolor";
import RemoveFormat from "@ckeditor/ckeditor5-remove-format/src/removeformat";
import WordCount from "@ckeditor/ckeditor5-word-count/src/wordcount";
import Autosave from "@ckeditor/ckeditor5-autosave/src/autosave";
import Alignment from "@ckeditor/ckeditor5-alignment/src/alignment";
import Underline from "@ckeditor/ckeditor5-basic-styles/src/underline";
import Essentials from "@ckeditor/ckeditor5-essentials/src/essentials";
import Paragraph from "@ckeditor/ckeditor5-paragraph/src/paragraph";
import BlockToolbar from "@ckeditor/ckeditor5-ui/src/toolbar/block/blocktoolbar";
import MediaEmbed from "../../plugins/ckeditor5/ckeditor5-media-embed/src/mediaembed";
import MediaEmbedToolbar from "../../plugins/ckeditor5/ckeditor5-media-embed/src/mediaembedtoolbar";
// import EmbedCaption from "../../plugins/ckeditor5/ckeditor5-media-embed/src/embedcaption";
import { removeWpTags, getYear, getMonth, getDate } from "../../utils/common";
import CustomUploadAdapterPlugin from "../../libs/CustomUploadAdapterPlugin";
import { ChromePicker } from "react-color";
import { CompactPicker } from "react-color";
import { convertChannelIdToName } from '../../utils/convert-channel';

const mp4Regex = /<\s*p[^>]*?><\s*a[^>]*?\.(m|M)(p|P)(4|3).>(.*?)<\s*\/\s*a><\s*\/\s*p>/g;

function MentionCustomization( editor ) {
  // The upcast converter will convert view <a class="mention" href="" data-user-id="">
  // elements to the model 'mention' text attribute.
  editor.conversion.for( 'upcast' ).elementToAttribute( {
      view: {
          name: 'a',
          key: 'data-mention',
          classes: 'mention',
          attributes: {
              href: true,
              'data-post-id': true,
              'data-thumb': true,
              'data-editor_type': true
          }
      },
      model: {
          key: 'mention',
          value: (viewItem) => {
            // console.log('upcast');
            // console.log(viewItem);
              // The mention feature expects that the mention attribute value
              // in the model is a plain object with a set of additional attributes.
              // In order to create a proper object use the toMentionAttribute() helper method:
              const mentionAttribute = editor.plugins.get( 'Mention' ).toMentionAttribute( viewItem, {
                  // Add any other properties that you need.
                  post_url: viewItem.getAttribute( 'href' ).replace('https://saostar.vn',''),
                  editor_type: viewItem.getAttribute('data-editor_type'),
                  thumb: viewItem.getAttribute('data-thumb'),
                  postId: viewItem.getAttribute( 'data-post-id' )
              } );

              return mentionAttribute;
          }
      },
      converterPriority: 'high'
  } );

  // Downcast the model 'mention' text attribute to a view <a> element.
  editor.conversion.for( 'downcast' ).attributeToElement( {
      model: 'mention',
      view: ( modelAttributeValue, writer ) => {
          // console.log('downcast');
          // Do not convert empty attributes (lack of value means no mention).
          if ( !modelAttributeValue ) {
              return;
          }
          if(writer){
            return writer.createAttributeElement( 'a', {
                class: 'mention',
                'data-mention': modelAttributeValue.id,
                'data-post-id': modelAttributeValue.id.replace('@',''),
                'data-thumb': modelAttributeValue.thumb,
                'style': `--background: url(${modelAttributeValue.thumb})`,
                'data-editor_type': modelAttributeValue.editor_type,
                'href': `https://saostar.vn${modelAttributeValue.post_url}`
            }, {
                // Make mention attribute to be wrapped by other attribute elements.
                priority: 20,
                // Prevent merging mentions together.
                id: modelAttributeValue.uid
            } );
          }
          
      },
      converterPriority: 'high'
  } );
}

class EditorMobi extends Component {
  constructor(props) {
    super(props);
    const post = props.post;
    const editorTypeSelected = props.editorTypeSelected || {
      type: 'normal',
      label: "Bài viết thường", 
      value: "normal" 
    };

    let content = removeWpTags(post.content_m);
    // console.log(content);
    this.myRef = React.createRef();
    this.ckRef = React.createRef();
    this.tmp_id = post.tmp_id || post.id;
    this.fy = getYear(post.createdAt);
    this.fm = getMonth(post.createdAt);
    this.fd = getDate(post.createdAt);
    this.title = post.title || "";
    this.countWordsE = 0;
    let that = this;
    this.state = {
      content: content != "" ? content : ` `,
      runUpdate: false,
      editor: null,
      editorConfiguration: {
        plugins: [
          Autoformat,
          Bold,
          Italic,
          BlockQuote,
          CKFinder,
          CKFinderUploadAdapter,
          Heading,
          Image,
          ImageCaption,
          ImageStyle,
          ImageToolbar,
          ImageUpload,
          Link,
          Mention,
          MentionCustomization,
          MediaEmbed,
          PasteFromOffice,
          ...(editorTypeSelected && editorTypeSelected.type !== "normal"
            ? [
                ImageResize,
                FontSize,
                FontColor,
                // FontFamily,
                FontBackgroundColor,
              ]
            : []),
          MediaEmbedToolbar,
          RemoveFormat,
          Autosave,
          WordCount,
          Alignment,
          Underline,
          Essentials,
          Paragraph,
          BlockToolbar,
          // EmbedCaption,
          // SimpleUploadAdapter
        ],
        // mention: {
        //     feeds: [
        //         {
        //             marker: '@',
        //             feed: this.getFeedVideoPodcast,
        //             itemRenderer: this.customVideoPodcastRenderer,
        //             dropdownLimit: 10,
        //         },
        //         {
        //             marker: '#',
        //             feed: this.getFeedPosts,
        //             itemRenderer: this.customVideoPodcastRenderer,
        //             dropdownLimit: 10,
        //         }
        //     ]
        // },
        toolbar: ["bold", "underline", "italic", "link", "removeFormat"],
        blockToolbar: [
          "heading",
          "|",
          // "fontFamily",
          "fontSize",
          "fontColor",
          "fontBackgroundColor",
          "alignment",
          "CKFinder",
          "|",
          "imageUpload",
          "mediaEmbed",
          "blockQuote",
          "|",
          "undo",
          "redo",
        ],
        image: {
          toolbar: [
            "imageTextAlternative",
            "|",
            "imageStyle:full",
            ...(editorTypeSelected && editorTypeSelected.type !== "normal"
              ? [
                  "|",
                  "imageStyle:side",
                  "|",
                  "imageStyle:alignRight",
                  "|",
                  "imageStyle:alignLeft",
                ]
              : []),
          ],
          styles: [
            "full",
            ...(editorTypeSelected && editorTypeSelected.type !== "normal"
              ? ["side", "alignRight", "alignLeft"]
              : []),
          ],
          resizeUnit: "px",
        },
        heading: {
          options: [
            {
              model: "paragraph",
              title: "Bình thường",
              class: "ck-heading_paragraph",
            },
            {
              model: "heading3",
              view: "h3",
              title: "Sub title - Sub heading",
              class: "ck-heading_heading3",
            },
            ...((post.is_live || post.content.indexOf("timeline-point") >= 0)
              ?
               [{
                  model: 'timeline',
                  view: {
                      name: 'p',
                      classes: 'timeline-point'
                  },
                  title: 'Timeline',
                  class: 'ck-heading_timeline',

                  // It needs to be converted before the standard 'heading2'.
                  converterPriority: 'high'
              }]
              :
              []),
          ],
        },
        simpleUpload: {
          // The URL the images are uploaded to.
          uploadUrl: `${process.env.REACT_APP_API}/media`,

          // Headers sent along with the XMLHttpRequest to the upload server.
          headers: {},
        },
        ckfinder: {
          // Upload the images to the server using the CKFinder QuickUpload command.
          uploadUrl:
            process.env.REACT_APP_UPLOAD_URL +
            "/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=" +
            this.tmp_id +
            "&editorType=" +
            editorTypeSelected.type +
            "&fy=" + this.fy +
            "&fm=" + this.fm +
            "&fd=" + this.fd +
            "&channel=" + convertChannelIdToName(props.channel, props.channels)
            ,
          options: {
            connectorInfo:
              "id=" + this.tmp_id + "&editorType=" + editorTypeSelected.type +  
              "&fy=" + this.fy +
              "&fm=" + this.fm +
              "&fd=" + this.fd +
              "&channel=" + convertChannelIdToName(props.channel, props.channels),
          },
        },
        extraPlugins: [CustomUploadAdapterPlugin],
        licenseKey: "UDPD4C6QLM748M7X3MV4AYKSFN4M4",
        postId: post.id,
        placeholder: "Nhập nội dung bài viết",
        wordCount: {
          displayWords: true,
          displayCharacters: true,
          onUpdate(stats) {
            that.countWordsE = stats.words;
          },
        },
      },
      stylePicker: false,
      styleColorBackGround: post.content_background || "#fff",
      pickerVisible: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    // console.log(nextProps);
    if (nextProps.editorTypeSelected !== this.props.editorTypeSelected) {
      // EDITOR TYPE = SPECIAL, MINI => use fontsize, fontcolor, fontfamily, fontbackgroundcolor
      // EDITOR TYPE = NORMAL => not use
      const nextType = nextProps.editorTypeSelected.type;
      const type = this.props.editorTypeSelected.type;
      const node = this.myRef.current;

      //ckfinder xử lý channel khi đổi editor type
      const channel = nextProps.channel !== this.props.channel ? nextProps.channel : this.props.channel;

      if (type === "normal" && nextType !== "normal") {
        this.setState(
          {
            editorConfiguration: {
              ...this.state.editorConfiguration,
              plugins: [
                ...this.state.editorConfiguration.plugins,
                FontSize,
                FontColor,
                // FontFamily,
                ImageResize,
                FontBackgroundColor,
              ],
              ckfinder: {
                uploadUrl:
                  process.env.REACT_APP_UPLOAD_URL +
                  "/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=" +
                  this.tmp_id +
                  "&editorType=" +
                  nextType +
                  "&fy=" + this.fy +
                  "&fm=" + this.fm +
                  "&fd=" + this.fd +
                  "&channel=" + convertChannelIdToName(channel, this.props.channels)
                  ,
                options: {
                  connectorInfo:
                    "id=" + this.tmp_id + "&editorType=" + nextType +
                    "&fy=" + this.fy +
                    "&fm=" + this.fm +
                    "&fd=" + this.fd +
                    "&channel=" + convertChannelIdToName(channel, this.props.channels)
                    ,
                },
              },
              image: {
                toolbar: [
                  ...this.state.editorConfiguration.image.toolbar,
                  "|",
                  "imageStyle:side",
                  "|",
                  "imageStyle:alignRight",
                  "|",
                  "imageStyle:alignLeft",
                ],
                styles: [
                  ...this.state.editorConfiguration.image.styles,
                  "side",
                  "alignRight",
                  "alignLeft",
                ],
                resizeUnit: "px",
              },
            },
          }, () => {
            this.initEditor(node);
          }
        );
      } else if (type !== "normal" && nextType === "normal") {
        const removedPlugins = [
          FontSize,
          FontColor,
          // FontFamily,
          ImageResize,
          FontBackgroundColor,
        ];
        const newImageConfig = {
          toolbar: ["imageTextAlternative", "|", "imageStyle:full"],
          styles: ["full"],
          resizeUnit: "px",
        };
        const newConfigPlugins = this.state.editorConfiguration.plugins.filter(
          (p) => !removedPlugins.includes(p)
        );
        this.setState(
          {
            editorConfiguration: {
              ...this.state.editorConfiguration,
              plugins: newConfigPlugins,
              ckfinder: {
                uploadUrl:
                  process.env.REACT_APP_UPLOAD_URL +
                  "/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=" +
                  this.tmp_id +
                  "&editorType=" +
                  nextType +
                  "&fy=" + this.fy +
                  "&fm=" + this.fm +
                  "&fd=" + this.fd +
                  "&channel=" + convertChannelIdToName(channel, this.props.channels)
                  ,
                options: {
                  connectorInfo:
                    "id=" + this.tmp_id + "&editorType=" + nextType +
                    "&fy=" + this.fy +
                    "&fm=" + this.fm +
                    "&fd=" + this.fd + 
                    "&channel=" + convertChannelIdToName(channel, this.props.channels)
                    ,
                },
              },
              image: newImageConfig,
            },
          }, () => {
            this.initEditor(node);
          }
        );
      } else if (type !== "normal" && nextType !== "normal") {
        this.setState(
          {
            editorConfiguration: {
              ...this.state.editorConfiguration,
              ckfinder: {
                uploadUrl:
                  process.env.REACT_APP_UPLOAD_URL +
                  "/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=" +
                  this.tmp_id +
                  "&editorType=" +
                  nextType +
                  "&fy=" + this.fy +
                  "&fm=" + this.fm +
                  "&fd=" + this.fd +
                  "&channel=" + convertChannelIdToName(channel, this.props.channels)
                  ,
                options: {
                  connectorInfo:
                    "id=" + this.tmp_id + "&editorType=" + nextType +
                    "&fy=" + this.fy +
                    "&fm=" + this.fm +
                    "&fd=" + this.fd +
                    "&channel=" + convertChannelIdToName(channel, this.props.channels)
                    ,
                },
              },
            },
          }, () => {
            this.initEditor(node);
          }
        );
      }
      if(nextProps.channel !== this.props.channel && nextProps.editorTypeSelected == this.props.editorTypeSelected){
        const channel = nextProps.channel;
        const nextType = this.props.editorTypeSelected.type;
        const node = this.myRef.current;
        this.setState(
          {
            editorConfiguration: {
              ...this.state.editorConfiguration,
              ckfinder: {
                uploadUrl:
                  process.env.REACT_APP_UPLOAD_URL +
                  "/s3/core/connector/php/connector.php?command=QuickUpload&type=Images&responseType=json&currentFolder=&id=" +
                  this.tmp_id +
                  "&editorType=" +
                  nextType +
                  "&fy=" + this.fy +
                  "&fm=" + this.fm +
                  "&fd=" + this.fd +
                  "&channel=" + convertChannelIdToName(channel, this.props.channels)
                  ,
                options: {
                  connectorInfo:
                    "id=" + this.tmp_id + "&editorType=" + nextType + "&fy=" + this.fy +
                    "&fm=" + this.fm +
                    "&fd=" + this.fd +
                    "&channel=" + convertChannelIdToName(channel, this.props.channels)
                    ,
                },
              },
            },
          }, () => {
            if(!this.state.editor){
              this.initEditor(node);
            }
            else{
              if(node &&  this.state.editor && typeof this.state.editor.destroy == "function"){
                // console.log("destroy editor");
                this.state.editor.destroy().then(e => {
                  this.initEditor(node);
                }).catch(error => {
                  console.log(error)
                });
              }
            }
          }
        );
      }
    }
    if(nextProps.post.content_m !== this.state.content){
      this.setState({
        content: nextProps.post.content_m
      })
    }
  }

  // componentDidUpdate(prevProps) {
  //   if (this.state.content !== this.props.post.content_m) {
  //     this.setState({
  //       content: this.props.post.content_m
  //     })
  //   }
  // }
  initEditor = (node) => {
    BalloonBlockEditor.create(
      node,
      this.state.editorConfiguration
    ).then(editor => {
      editor.model.document.on('change:data',() => {
        // console.log("onchange reinit");
        const data = editor.getData();
        // process video mp4
        let strTxt = data.match(mp4Regex);

        if (!this.state.updateData && strTxt && strTxt.length > 0) {
          this.updateData(data);
        } else {
          this.setState({ runUpdate: false });
        }
        this.props.onChange && this.props.onChange(data);
      });

      editor.ui.focusTracker.on( 'change:isFocused', ( evt, name, isFocused ) => {
          if ( !isFocused ) {
              // Do whatever you want with current editor data:
              // console.log("onblur 2");
              const data = editor.getData();
              this.props.onBlur && this.props.onBlur(data);
          }
      });

      this.setState({ editor });
    }).catch(error => {
      console.log(error);
    });
    // this.state.editor.destroy().then(() => {
    // });
  }

  updateData = (updateData) => {
    let regEx = "";
    let strTxt = updateData.match(mp4Regex);
    if (strTxt && strTxt.length > 0) {
      this.setState(
        {
          runUpdate: true,
        },
        () => {
          let pattern = strTxt[0].match(/(http(s)?:\/\/|(w){3}).*?\.(?:(m|M)(p|P)4)/g);
          let patternAudio = strTxt[0].match(/(http(s)?:\/\/|(w){3}).*?\.(?:(m|M)(p|P)3)/g);
          let newData;
          if(pattern && pattern[0]){
            let dataReplace = `<figure class="media ck-widget">
              <div class="ck-media__wrapper" data-oembed-url="${pattern[0]}">
              <div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">
              <video style="position:absolute; height: 100%; width: 100%" controls="">
              <source src="${pattern[0]}" type="video/mp4">
              Your browser does not support HTML5 video.
              </video>
              </div>
              </div>
              </figure>`;
              newData = updateData.replace(
                mp4Regex,
                dataReplace
              );
          }
          if(patternAudio && patternAudio[0]){
            let dataReplace = `<figure class="media ck-widget">
              <div class="ck-media__wrapper" data-oembed-url="${patternAudio[0]}">
              <div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 8%;">
              <audio style="position:absolute; height: 100%; width: 100%" controls="">
              <source src="${patternAudio[0]}" type="audio/mpeg">
              Your browser does not support HTML5 audio.
              </audio>
              </div>
              </div>
              </figure>`;
            newData = updateData.replace(
                mp4Regex,
                dataReplace
              );
          }
          this.state.editor.setData(newData);
        }
      );
    }
  };

  replaceIframe(content) {

    if (content) {
      const patternIframe = /<iframe.*?\/iframe>/gm;
  
      const replacedContent = content.replace(patternIframe, (iframe) => {
        const pattern = /youtube\.com\/embed\/([\w-]+)/g;
        const match = pattern.exec(iframe);
  
        if (match && match.length > 1) {
          const youtubeId = match[1];
  
          const newIframe = `
          <figure class="media">
            <div data-oembed-url="https://www.youtube.com/watch?v=${youtubeId}">
              <div style="position: relative; padding-bottom: 100%; height: 0; padding-bottom: 56.2493%;">
                <iframe src="https://www.youtube.com/embed/${youtubeId}" style="position: absolute; width: 100%; height: 100%; top: 0; left: 0;" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen=""></iframe>
              </div>      
            </div>
          </figure>        
        `;
          return newIframe;
        }
  
        return iframe;
      });
      // console.log(replacedContent);
      return replacedContent;
    }
    // console.log(content);
    return content;
  }
  getFeedVideoPodcast( queryText ) {
    // As an example of an asynchronous action, return a promise
    // that resolves after a 100ms timeout.
    // This can be a server request or any sort of delayed action.
    // console.log(this);

    return new Promise( resolve => {
        setTimeout( () => {
            let url = 'https://api.saostar.vn/posts?editor_type=podcast,video';
            if(queryText){
              url += '&q='+ encodeURIComponent(queryText.toLowerCase());
            }
            return fetch(url)
            .then(response => {
              return response.json();
            })
            .then( data => {
              let itemDisplay = data.posts;
              itemDisplay.map(item => {
                item.id = "@" + item.id;
                item.text = item.title;
                item.thumb = item.editor_type == 'podcast' ? item.img_ver : item.img_hor
              })
              resolve( itemDisplay );
            });
        }, 500 );
    } );
  }
  getFeedPosts( queryText ) {
      // As an example of an asynchronous action, return a promise
      // that resolves after a 100ms timeout.
      // This can be a server request or any sort of delayed action.
      console.log(this);

      return new Promise( resolve => {
          setTimeout( () => {
              let url = 'https://api.saostar.vn/posts?editor_type=normal,special,mini';
              if(queryText){
                url += '&q='+ encodeURIComponent(queryText.toLowerCase());
              }
              return fetch(url)
              .then(response => {
                return response.json();
              })
              .then( data => {
                let itemDisplay = data.posts;
                itemDisplay.map(item => {
                  item.id = "#" + item.id;
                  item.text = item.title;
                })
                resolve( itemDisplay );
              });
          }, 500 );
      } );
  }

  customVideoPodcastRenderer( item ) {
      console.log(item);
      const itemElement = document.createElement( 'span' );

      itemElement.classList.add( 'custom-item' );
      itemElement.classList.add( 'p-2' );
      itemElement.id = `mention-list-item-id-${ item.id }`;
      
      itemElement.textContent = `${ item.title } `; 

      const editor_type = document.createElement( 'span' );

      editor_type.classList.add('custom-item-editortype');
      editor_type.classList.add('p-2');
      editor_type.classList.add('text-uppercase');
      if(item.editor_type == 'podcast'){
        editor_type.classList.add('bg-primary');  
      }
      if(item.editor_type == 'video'){
        editor_type.classList.add('bg-dark'); 
      }
      if(item.editor_type == 'normal'){
        editor_type.classList.add('bg-info'); 
      }
      if(item.editor_type == 'mini'){
        editor_type.classList.add('bg-danger'); 
      }
      if(item.editor_type == 'special'){
        editor_type.classList.add('bg-warning'); 
      }
      if(item.editor_type == 'normal'){
        editor_type.textContent = `Thường`;
      }
      else{
        editor_type.textContent = item.editor_type;
      }
      itemElement.appendChild( editor_type );

      return itemElement;
  }
  
  render() {
    const { content } = this.state;
    const type = this.props.editorTypeSelected ? this.props.editorTypeSelected.type : 'normal';
    // console.log(type);
    const bgE = this.props.styleColorBackGround;
    const styleImageBackGround = this.props.styleImageBackGround;
    const cover_m = this.props.post.cover_m;
    return (
      <>
        {content != "" && (
          <div
            style={
              type == "special" || type == "mini"
                ? {
                    backgroundColor: bgE,
                    backgroundImage: `url('${styleImageBackGround}')`,
                  }
                : {}
            }
            className="editor-mobi"
          >
            { ((type == "special" || type == "mini") && cover_m)?
              <>
                <div>
                  <img src={cover_m} className="d-block mx-auto cover"/>
                  {type == "mini" &&
                    <div className="w--800 ma art-sapo ff-medium mt-6 text-center mb-10">
                      {this.props.post.description}
                    </div>
                  }
                </div>
              </>
              :
              <></>
            }
            <div ref={this.myRef} className={((this.props.post && this.props.post.is_live) || this.props.post.content.indexOf("timeline-point") >= 0) ? "post-live" : ""}>
              <CKEditor
                ref={this.ckRef}
                editor={BalloonBlockEditor}
                config={this.state.editorConfiguration}
                data={this.replaceIframe(this.state.content)}
                // content={this.replaceIframe(this.state.content)}
                onInit={(editor) => {
                  // You can store the "editor" and use when it is needed.
                  // console.log("Editor is ready to use!", editor);
                  this.setState({ editor: editor });
                }}
                onChange={(event, editor) => {
                  const data = editor.getData();
                  // console.log(data);
                  // process video mp4
                  let strTxt = data.match(mp4Regex);
                  {/*console.log(strTxt);*/}
                  if (!this.state.updateData && strTxt && strTxt.length > 0) {
                    {/*console.log("1232134");*/}
                    {/*console.log(data);*/}
                    this.updateData(data);
                  } else {
                    {/*console.log("123213");*/}
                    {/*console.log(data);*/}
                    this.setState({ runUpdate: false });
                  }
                  this.props.onChange && this.props.onChange(data);
                }}
                onBlur={(event, editor) => {
                  const data = editor.getData();
                  this.props.onBlur && this.props.onBlur(data);
                }}
                onFocus={(event, editor) => {
                  // console.log("Focus.", editor);
                }}
              />
            </div>
            <blockquote>
              <p>Số từ trong bài viết: {this.countWordsE}.</p>
            </blockquote>
          </div>
        )}
      </>
    );
  }
}

EditorMobi.propTypes = {};

export default EditorMobi;
